<div class="{{ card_class }}">
    <img src="{{ card_img }}" class="icon-img" />
    <h3>{{ card_title }}</h3>
    <p [innerHtml]="card_text">{{card_text}}</p>

    @if (card_img_bottom.length > 0) {
        <img src="{{ card_img_bottom }}" class="img-bottom" />
        <br/><br/>
    }
    <span class="vm_logo_tag" 
        [class.closed]="i_card != 'vemmeteoro'">
        V<span>M</span>
    </span>

    <app-btn i_type="primary-txt" i_destiny="{{ i_card }}" [i_label]="card_btn_label"></app-btn>
</div>